export default __webpack_public_path__ + "static/media/img-project_3.3efdb915.png";